module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Ratio":"Ratio","Combat skill":"Combat skill","Endurance":"Endurance","Round":"Fight"},"fr":{"Ratio":"Quotient","Combat skill":"Habilité","Endurance":"Endurance","Round":"Combatre"}}')
  delete Component.options._Ctor
}
